import React from 'react'
import { useState } from 'react';
import ModalViewerWrapper from "./model-viewer-wrapper/model-viewer-wrapper";

const Card = ({src,title,price,desc}) => {
  const [showAnnotation, setShowAnnotation] = useState(true);
  return (
    <div class="w-[75vw] sm:w-[55vw] md:w-[45vw] lg:w-[25vw] rounded overflow-hidden text-primary py-4 shadow-lg">
      <div class="w-full h-[25vh] sm:h-[15vh] md:h-[25vh]">
                        <ModalViewerWrapper
                          alt="3d-model"
                          arScale="fixed"
                          shadow-intensity="1"
                          camera-controls id="test"
                          className={"model"}
                          exposure="1"
                          camera-orbit="1.301deg 47.24deg 0.625m"
                          field-of-view="30deg"
                          {...src}
                          model={src.model}
                      >
                      </ModalViewerWrapper>
        </div>
      <div class="block min-h-[1.5rem] pt-2 ml-[1.5rem]">
        <input
          class="relative float-left mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
          type="checkbox"
          onChange={() => { setShowAnnotation(!showAnnotation) }}
          checked={showAnnotation}
          value="" />
        <label
          class="inline-block pl-[0.15rem] hover:cursor-pointer"
          for="checkboxChecked">
          Show Details
        </label>
      </div>
      <div class="px-6 pb-2">
        <div class="text-primary font-bold text-xl">{title}</div>
        <p class="text-gray-700">
          {desc}
        </p>
      </div>
      
    </div>
  )
}

export default Card;